// libs
import React, { memo } from "react";
import { SerializedStyles } from "@emotion/core";

// global components
import WithStyles from "shared/components/WithStyles";

// styles
import { loaderCss } from "./styles";

// defs
interface ILoaderProps {
    dotCount?: number;
    fixed?: boolean;
    cssProps?: SerializedStyles | SerializedStyles[];
}

const Loader = ({ dotCount = 8, fixed = false, cssProps }: ILoaderProps) => {
    const dots = (key: number) => (
        <div className="bubble-container" data-test="dots" key={key}>
            <div className="bubble" />
        </div>
    );

    const dotsList = new Array(dotCount).fill(dots);
    const classNameApplied = `loading-container ${fixed ? "fixed" : ""}`;

    const css = [loaderCss, cssProps !== undefined && cssProps];

    return (
        <WithStyles cssProps={css} data-test="loader-cnt">
            <div className={classNameApplied}>
                <div className="loader">
                    <div className="loading-spinning-bubbles">
                        {dotsList.map((dot, i) => dot(i))}
                    </div>
                </div>
            </div>
        </WithStyles>
    );
};

export default memo(Loader);
